import client from './client';

export const getNotifications = (params) => client.get('/notifications', { params });

export const getNotificationSummary = () => client.get('/notifications/summary');
